import { brandPrimitives, functionalPrimitives, neutralPrimitives } from "@maeiz/tokens";
import { DocPage, Section, Demo, SpecTable, DoDont } from "../../components/DocChrome";

const groups = [
    {
        title: "Brand",
        colors: [
            ["Blue", brandPrimitives.blue.DEFAULT],
            ["Blue light", brandPrimitives.blue.light],
            ["Blue dark", brandPrimitives.blue.dark],
            ["Gold", brandPrimitives.gold.DEFAULT],
            ["Gold light", brandPrimitives.gold.light],
            ["Gold dark", brandPrimitives.gold.dark],
        ],
    },
    {
        title: "Functional",
        colors: [
            ["Secondary / info", functionalPrimitives.secondary.DEFAULT],
            ["Warning", functionalPrimitives.warning.DEFAULT],
            ["Success", functionalPrimitives.success.DEFAULT],
            ["Danger", functionalPrimitives.danger.DEFAULT],
        ],
    },
    {
        title: "Neutrals",
        colors: [
            ["Dark / fg", neutralPrimitives.dark],
            ["Secondary text", neutralPrimitives.secondary],
            ["Border", neutralPrimitives.border],
            ["Light / bg", neutralPrimitives.light],
            ["Ink", neutralPrimitives.ink],
            ["Navy surface", neutralPrimitives.navy],
        ],
    },
];

export function ColorPage() {
    return (
        <DocPage
            title="Color"
            description="Immutable MAEIZ Workspace palette. Gold is #C9A736. Blue is #1E3A8A."
        >
            {groups.map((g) => (
                <Section key={g.title} title={g.title}>
                    <Demo>
                        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                            {g.colors.map(([name, hex]) => (
                                <div key={name} className="flex items-center gap-3">
                                    <span
                                        className="h-10 w-10 shrink-0 rounded-mz-md border border-black/5 shadow-mz-sm"
                                        style={{ backgroundColor: hex }}
                                    />
                                    <div>
                                        <p className="text-sm font-medium text-neutral-dark dark:text-white">
                                            {name}
                                        </p>
                                        <p className="font-mono text-xs text-neutral-secondary">
                                            {hex}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Demo>
                </Section>
            ))}
            <Section title="Tailwind aliases">
                <SpecTable
                    rows={[
                        ["bg-primary / text-primary", brandPrimitives.blue.DEFAULT],
                        ["bg-gold / text-gold", brandPrimitives.gold.DEFAULT],
                        ["bg-warning", functionalPrimitives.warning.DEFAULT],
                        ["bg-success / bg-danger", "Functional states"],
                        ["bg-secondary", "Info / aqua accent (not brand)"],
                    ]}
                />
            </Section>
            <DoDont
                doItems={[
                    "Use gold for logo accents, verified badges, premium KPIs",
                    "Use warning amber for alerts",
                ]}
                dontItems={[
                    "Use #D4AF37 (deprecated)",
                    "Paint large backgrounds with gold",
                    "Mix panel-local palettes",
                ]}
            />
        </DocPage>
    );
}
